export default "/ofd.39bd2c90-0351f6.svg?svgr";